import { useCallback, useContext, useMemo } from 'react';
import myxss from 'react-form-builder2/lib/form-elements/myxss';

import { FormRuntimeContext } from '../../form-renderer/FormRuntimeContext';
import { fillTemplate } from '../../../utils/templateText';

/**
 * Fills `{{field_name}}` with the visitor's answers. `html` also sanitises the
 * result for `dangerouslySetInnerHTML`; `text` is for plain values such as an
 * image URL (e.g. `.../{{gender}}.png`). Outside the live renderer (builder
 * canvas, preview) placeholders are left as typed so the author can see where
 * answers will appear.
 */
export const usePipedText = () => {
  const { getAnswers } = useContext(FormRuntimeContext);
  const answers = useMemo(() => (getAnswers ? getAnswers() : null), [getAnswers]);

  const text = useCallback(
    (value?: string): string => {
      const raw = value || '';
      return answers ? fillTemplate(raw, answers) : raw;
    },
    [answers],
  );

  const html = useCallback((value?: string): string => myxss.process(text(value)), [text]);

  return { html, text };
};
